import type { ActivityModule } from '../../core/activity';
import { mountPlanegame } from './ui';
import levelsData from './levels.json';
import './style.css';

export const planegame: ActivityModule = {
  id: 'planegame',
  title: 'Caça-números (avião)',
  description: 'Pilote o avião e pegue os números das nuvens em ordem crescente.',
  ageMin: 5,
  ageMax: 9,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/planegame/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountPlanegame,
};
